module.exports = __webpack_public_path__ + "static/media/icon_6.69609803.svg";